'use client'
import { useContext } from 'react'
import { CampaignContext } from '@shared/hooks/CampaignProvider'

export const useCampaign = () => useContext(CampaignContext)
